import React from 'react';
import { Input, Alert } from 'antd';
import PropTypes from 'prop-types';
import s from './style.less';

const renderField = ({
  input,
  label,
  type,
  meta: { touched, error },
  placeholder,
}) => (
  <div className={s.root}>
    <label htmlFor={input.name} {...label && { className: s.flex }}>
      {label && <div>{label}</div>}
      <div>
        <Input
          {...input}
          id={input.name}
          placeholder={placeholder}
          type={type}
        />
        {touched && error && <Alert message={error} type="error" />}
      </div>
    </label>
  </div>
);
renderField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.object,
  placeholder: PropTypes.string,
};

export default renderField;
